'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; desc = parent = getter = undefined; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

require('./VrPlayer.css');

var _Controls = require('./Controls');

var _Controls2 = _interopRequireDefault(_Controls);

var _Video = require('./Video');

var _Video2 = _interopRequireDefault(_Video);

var VrPlayer = (function (_React$Component) {
    _inherits(VrPlayer, _React$Component);

    function VrPlayer(props) {
        _classCallCheck(this, VrPlayer);

        _get(Object.getPrototypeOf(VrPlayer.prototype), 'constructor', this).call(this, props);
        this.state = {
            isPlaying: false,
            isMute: false,
            isFullscreen: false,
            position: 0,
            sources: []
        };
    }

    _createClass(VrPlayer, [{
        key: 'render',
        value: function render() {
            var _this = this;

            return _react2['default'].createElement(
                'div',
                { className: 'VrPlayer' },
                _react2['default'].createElement(_Video2['default'], { ref: 'video',
                    sources: this.state.sources,
                    onFullScreen: this.fullScreen.bind(this),
                    onPositionChange: function (p) {
                        return _this.setState({ position: p });
                    },
                    onPlayPause: this.playPause.bind(this),
                    onMute: this.mute.bind(this),
                    keys: this.props.keys }),
                _react2['default'].createElement(_Controls2['default'], { isPlaying: this.state.isPlaying,
                    onPlayPause: this.togglePlayPause.bind(this),
                    isMute: this.state.isMute,
                    onMute: this.toggleMute.bind(this),
                    isFullscreen: this.state.isFullscreen,
                    onFullScreen: this.toggleFullScreen.bind(this),
                    position: this.state.position,
                    onPositionChange: this.changePosition.bind(this),
                    onLocalVideoSelected: this.localVideoSelected.bind(this),
                    brand: this.props.brand,
                    title: this.props.title
                })
            );
        }
    }, {
        key: 'playPause',
        value: function playPause(playing) {
            this.setState({ isPlaying: playing });
        }
    }, {
        key: 'togglePlayPause',
        value: function togglePlayPause() {
            this.refs.video.playPause();
        }
    }, {
        key: 'mute',
        value: function mute(muted) {
            this.setState({ isMute: muted });
        }
    }, {
        key: 'toggleMute',
        value: function toggleMute() {
            this.refs.video.toggleMute();
        }
    }, {
        key: 'fullScreen',
        value: function fullScreen(isFullscreen) {
            this.setState({ isFullscreen: isFullscreen });
        }
    }, {
        key: 'toggleFullScreen',
        value: function toggleFullScreen() {
            this.refs.video.goFullScreen();
        }
    }, {
        key: 'changePosition',
        value: function changePosition(percentage) {
            this.refs.video.setPosition(percentage);
        }
    }, {
        key: 'localVideoSelected',
        value: function localVideoSelected(videoSource) {
            this.setState({ sources: [videoSource] });
        }
    }, {
        key: 'zeroSensor',
        value: function zeroSensor() {
            this.refs.video.zeroSensor();
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.setState({ sources: this.props.sources });
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            var keys = this.props.keys;
            if (window) {
                window.addEventListener('keypress', function (event) {
                    switch (String.fromCharCode(event.charCode)) {
                        case keys.fullScreen.toLowerCase():
                            _this2.toggleFullScreen();
                            break;
                        case keys.zeroSensor.toLowerCase():
                            _this2.zeroSensor();
                            break;
                        case keys.playPause.toLowerCase():
                            _this2.togglePlayPause();
                            break;
                    }
                }, true);
            }
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(newProps) {
            if (this.props.sources !== newProps.sources) {
                this.setState({ sources: newProps.sources });
            }
        }
    }]);

    return VrPlayer;
})(_react2['default'].Component);

VrPlayer.propTypes = {
    sources: _react.PropTypes.array.isRequired,
    title: _react.PropTypes.string,
    brand: _react.PropTypes.string,
    keys: _react.PropTypes.object
};

VrPlayer.defaultProps = {
    sources: [],
    title: '',
    brand: '',
    keys: {
        left: 'A',
        right: 'D',
        up: 'W',
        down: 'S',
        rotateLeft: 'Q',
        rotateRight: 'E',
        fullScreen: 'F',
        zeroSensor: 'Z',
        playPause: ' '
    }
};

exports['default'] = VrPlayer;
module.exports = exports['default'];


/** WEBPACK FOOTER **
 ** ./~/babel-loader!./source/VrPlayer.jsx
 **/